export default function (url) {
    let baseUrl = url;
    return function (name) {
        return baseUrl + name;
    }
}